<template>
  <div> 
    <NavbarLanding />
    <v-container class="py-6" >
      <v-row justify="center">
        <v-col cols="12">
          <!-- Título aprimorado -->
          <div class="text-center mb-8">
            <h1 class="text-h2 font-weight-bold mb-2 main-title">
              {{
                tipo === "despedidas" ? "Memorial Online" : "Velório Virtual"
              }}
            </h1>
            <p class="text-h6 text-grey-darken-1">
              {{
                tipo === "despedidas"
                  ? "Honrando memórias, compartilhando lembranças"
                  : "Transmissões em tempo real"
              }}
            </p>
          </div>

          <div id="despedidas" v-if="tipo === 'despedidas'">
            <div class="section-header mb-6">
              <v-row justify="center">
                <v-col cols="12" sm="10" md="8" lg="6">
                  <v-card
                    elevation="0"
                    class="search-card rounded-pill overflow-hidden"
                  >
                    <v-text-field
                      v-model="searchQuery"
                      prepend-inner-icon="mdi-magnify"
                      label="Digite o nome do falecido"
                      placeholder="Digite o nome do falecido"
                      single-line
                      hide-details
                      class="search-field"
                      clearable
                      @click:clear="limparPesquisa"
                      @keyup.enter="filtrarPostagens"
                      variant="solo-filled"
                      bg-color="grey-lighten-5"
                    >
                    </v-text-field>
                    <v-btn
                      color="#343F53"
                      @click="filtrarPostagens"
                      height="55px"
                      style="border-radius: 0"
                      :loading="loading"
                    >
                      <v-icon>mdi-magnify</v-icon>
                      <span class="d-none d-sm-flex ml-2">Pesquisar</span>
                    </v-btn>
                  </v-card>
                </v-col>
              </v-row>
            </div>
            <div v-if="loading" class="loading-state">
              <v-progress-circular
                indeterminate
                color="primary"
                size="48"
                class="mb-4"
              ></v-progress-circular>
              <h3 class="text-h6 mb-2">Carregando despedidas...</h3>
              <p class="text-body-2 text-grey">Por favor, aguarde um momento</p>
            </div>
            <!-- Estado vazio melhorado -->
            <v-fade-transition>
              <div v-if="despedidas.length === 0 && !loading" class="empty-state">
                <v-icon size="64" color="grey-lighten-1"
                  >mdi-account-search</v-icon
                >
                <h3 class="text-h6 mt-4 mb-2">Nenhuma despedida encontrada</h3>
                <p class="text-body-2 text-grey">
                  Tente ajustar sua busca ou explore outras seções
                </p>
              </div>
            </v-fade-transition>

            <v-row v-if="despedidas.length > 0" class="mb-4">
              <v-col
                v-for="(item, index) in despedidas"
                :key="'despedida-' + index"
                cols="12"
                sm="6"
                md="4"
                lg="3"
              >
                <v-card
                  @click="verHomenagem(item.id)"
                  elevation="3"
                  class="memorial-card"
                  hover
                >
                  <!-- Header do card com gradient -->
                  <div
                    class="card-header"
                    :style="{
                      backgroundImage: `url(${require('@/assets/pack-banners/' +
                        item.foto_fundo +
                        '.jpg')})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                    }"
                  >
                    <v-avatar size="80" class="memorial-avatar">
                      <v-img
                        v-if="getFotoPerfilUrl(item.nome_arquivo_foto_perfil)"
                        :src="getFotoPerfilUrl(item.nome_arquivo_foto_perfil)"
                        alt="Foto do perfil"
                      ></v-img>

                      <img
                        v-else
                        :src="
                          require('@/assets/' +
                            item.pessoa_falecida.sexo +
                            '.png')
                        "
                        alt="Foto padrão"
                        width="80"
                        height="80"
                      />
                    </v-avatar>
                  </div>

                  <v-card-text class="text-center pt-4 px-2">
                    <h3 class="text-h6 font-weight-bold mb-2 falecido-nome">
                      {{ item.pessoa_falecida?.nome_social || item.pessoa_falecida?.nome }}
                    </h3>
                    <div class="date-container">
                      <!-- Data de nascimento -->
                      <div class="date-item d-flex align-center">
                        <v-icon size="16" color="#343F53" class="mr-1"
                          >mdi-star</v-icon
                        >
                        <span class="text-body-2 text-grey-darken-1">
                          {{
                            formatDate(item.pessoa_falecida?.data_nascimento)
                          }}
                        </span>
                      </div>

                      <!-- Separador -->
                      <div class="date-separator mx-2">-</div>

                      <!-- Data de falecimento -->
                      <div class="date-item d-flex align-center">
                        <v-icon size="16" color="#343F53" class="mr-1"
                          >mdi-cross</v-icon
                        >
                        <span class="text-body-2 text-grey-darken-1">
                          {{
                            formatDate(item.pessoa_falecida?.data_falecimento)
                          }}
                        </span>
                      </div>
                    </div>
                  </v-card-text>

                  <v-card-actions class="justify-center pb-4">
                    <v-btn
                      color="#343F53"
                      variant="elevated"
                      size="small"
                      prepend-icon="mdi-heart"
                    >
                      Ver memorial
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </div>

          <!-- Aba de Despedidas Ao Vivo -->
          <div id="aovivo" v-if="tipo === 'aovivo'">
            <div v-if="loading" class="loading-state">
              <v-progress-circular
                indeterminate
                color="primary"
                size="48"
                class="mb-4"
              ></v-progress-circular>
              <h3 class="text-h6 mb-2">Carregando transmissões...</h3>
              <p class="text-body-2 text-grey">Por favor, aguarde um momento</p>
            </div>

            <div v-else-if="despedidasAoVivo.length === 0" class="empty-state">
              <v-icon size="64" color="grey-lighten-1">mdi-video-off</v-icon>
              <h3 class="text-h6 mt-4 mb-2">
                Nenhuma transmissão ao vivo no momento
              </h3>
              <p class="text-body-2 text-grey">
                Volte mais tarde para acompanhar as cerimônias
              </p>
            </div>

            <v-row v-else class="mb-4">
              <v-col
                v-for="(item, index) in despedidasAoVivo"
                :key="'aovivo-' + index"
                cols="12"
                sm="6"
                md="4"
                lg="3"
              >
                <v-card
                  @click="verHomenagem(item.id)"
                  elevation="3"
                  class="memorial-card-velorio"
                  hover
                >
                  <!-- Header com background + chip ao vivo -->
                  <div
                    class="card-header"
                    :style="{
                      backgroundImage: `url(${require('@/assets/pack-banners/' +
                        item.foto_fundo +
                        '.jpg')})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      position: 'relative',
                    }"
                  >
                    <!-- Chip ao vivo -->
                    <v-chip
                      color="red"
                      text-color="white"
                      size="small"
                      class="live-chip"
                      prepend-icon="mdi-broadcast"
                      style="
                        position: absolute;
                        top: 8px;
                        left: 8px;
                        z-index: 1;
                      "
                      variant="flat"
                    >
                      Ao Vivo
                    </v-chip>

                    <!-- Avatar -->
                    <v-avatar size="80" class="memorial-avatar">
                      <v-img
                        v-if="getFotoPerfilUrl(item.nome_arquivo_foto_perfil)"
                        :src="getFotoPerfilUrl(item.nome_arquivo_foto_perfil)"
                        alt="Foto do perfil"
                      ></v-img>
                      <img
                        v-else
                        :src="
                          require('@/assets/' +
                            item.pessoa_falecida.sexo +
                            '.png')
                        "
                        alt="Foto padrão"
                        width="80"
                        height="80"
                      />
                    </v-avatar>
                  </div>

                  <!-- Nome e infos -->
                  <v-card-text class="text-center pt-4 pb-0">
                    <h3 class="text-h6 font-weight-bold mb-2 falecido-nome">
                      {{ item.pessoa_falecida?.nome_social || item.pessoa_falecida?.nome }}
                    </h3>

                    <div
                      class="text-body-2 text-grey-darken-1 d-flex flex-column align-start gap-2"
                    >
                      <!-- Data do velório -->
                      <div class="d-flex align-center">
                        <v-icon size="16" color="#343F53" class="mr-1"
                          >mdi-calendar</v-icon
                        >
                        <span>
                          Início:
                          {{
                            formatDateHora(item.apresentacao.dataHoraInicial)
                          }}</span
                        >
                      </div>
                      <!-- Data do velório -->
                      <div class="d-flex align-center">
                        <v-icon size="16" color="#343F53" class="mr-1"
                          >mdi-calendar</v-icon
                        >
                        <span>
                          Fim:
                          {{
                            formatDateHora(item.apresentacao.dataHoraFinal)
                          }}</span
                        >
                      </div>

                      <!-- Capela -->
                      <div class="d-flex align-justify justify-center">
                        <v-icon size="16" color="#343F53" class="mr-1"
                          >mdi-church</v-icon
                        >
                        <span>{{ item.local_velorio }}</span>
                      </div>
                    </div>
                  </v-card-text>

                  <v-card-actions class="justify-center pb-4">
                    <v-btn
                      color="#343F53"
                      variant="elevated"
                      size="small"
                      prepend-icon="mdi-video"
                    >
                      Ver transmissão
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <Footer />
  </div>
</template>

<script>
import { http, getFotoPerfilUrl } from "@/services/config";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import Footer from "../landingpage/Footer.vue";
import NavbarLanding from "../landingpage/Navbar.vue";
dayjs.locale("pt-br");
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
  name: "ListaPostagensPublicas",
  components: {
    NavbarLanding,
    Footer,
  },
  data() {
    return {
      activeTab: "despedidas",
      searchQuery: "",
      despedidas: [],
      despedidasAoVivo: [],
      loading: false,
      tipo: this.$route.params.tipo,
    };
  },
  watch: {
    "$route.params.tipo": {
      immediate: true,
      handler(newTipo) {
        this.tipo = newTipo;
      },
    },
  },
  mounted() {
    this.carregarPostagens();
    this.carregarDespedidasAoVivo();
  },
  methods: {
    getFotoPerfilUrl,
    formatarData(dataString) {
      if (!dataString) return "";

      const data = new Date(dataString);
      const dia = data.getDate().toString().padStart(2, "0");
      const mes = (data.getMonth() + 1).toString().padStart(2, "0");
      const ano = data.getFullYear();
      const hora = data.getHours().toString().padStart(2, "0");
      const minutos = data.getMinutes().toString().padStart(2, "0");

      return `${dia}/${mes}/${ano} às ${hora}:${minutos}`;
    },

    formatDate(date) {
      if (!date) return "";
      return dayjs(date).format("DD/MM/YYYY");
    },
    formatDateHora(date) {
      if (!date) return "";
      return dayjs(date).format("DD/MM/YYYY HH:mm");
    },
    filtrarPostagens() {
      if (this.searchQuery === "" || !this.searchQuery) {
        toast.warning("Por favor, insira um termo de busca.");
        return;
      }
      this.loading = true;
      http
        .get(`/exibicao/despedidas/busca?nome=${this.searchQuery}`)
        .then((response) => {
          this.despedidas = response.data || [];
          this.loading = false;
        })
        .catch((error) => {
          console.error("Erro ao carregar postagens:", error);
          toast.error("Erro ao buscar despedidas");
          this.loading = false;
        });
    },

    limparPesquisa() {
      // Recarrega todas as postagens quando o campo é limpo
      this.loading = true;
      this.carregarPostagens();
    },

    carregarPostagens() {
      this.loading = true;
      http
        .get(`/exibicao/despedidas/ultimas`)
        .then((response) => {
          this.despedidas = response.data || [];
          this.loading = false;
        })
        .catch((error) => {
          console.error("Erro ao carregar postagens:", error);
          this.loading = false;
        });
    },
    carregarDespedidasAoVivo() {
      if (this.loadingMore) return;
      this.loadingMore = true;
      this.page += 1;
      http
        .get(`/exibicao/despedidas/apresentadas`)
        .then((response) => {
          this.despedidasAoVivo = response.data || [];
          this.loadingMore = false;
        })
        .catch((error) => {
          console.error("Erro ao carregar mais postagens:", error);
          this.loadingMore = false;
        });
    },
    verHomenagem(despedidaId) {
      if (!despedidaId) return;
      this.$router.push(`/despedida/${despedidaId}`);
    },
  },
};
</script>

<style scoped>
/* Título principal */
.main-title {
  color: #343f53;
  font-weight: 700;
  background-clip: text;
}

/* Estados vazios e loading */
.empty-state,
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 24px;
  text-align: center;
}

/* Cards de memorial */
.memorial-card {
  border-radius: 0px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  overflow: hidden;
  height: 20rem;
}

.memorial-card-velorio {
  border-radius: 0px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  overflow: hidden;
  height: 22rem;
}

.falecido-nome {
  height: 4rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-height: 1.2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.date-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.date-item {
  white-space: nowrap;
}

.date-separator {
  color: #6c757d;
}

.memorial-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15) !important;
}

.card-header {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.memorial-avatar {
  border: 4px solid white;
  background-color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* Cards de homenagem */
.homenagem-card {
  border-radius: 12px !important;
  transition: all 0.3s ease;
  border: 1px solid #e9ecef;
}

.homenagem-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1) !important;
}

.message-text {
  line-height: 1.6;
  color: #495057;
}

/* Responsividade */
@media (max-width: 960px) {
  .main-title {
    font-size: 2rem !important;
  }

  .search-button span {
    display: none;
  }
}

@media (max-width: 600px) {
  .main-title {
    font-size: 1.8rem !important;
  }

  .section-header {
    padding: 16px 0;
  }

  .search-card {
    border-radius: 8px !important;
  }
}

/* Animações */
.v-card {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.v-chip {
  transition: all 0.2s ease;
}

.v-btn {
  transition: all 0.2s ease;
}

/* Estilo do campo de busca */
.search-card {
  display: flex;
  overflow: hidden;
  transition: all 0.3s ease;
}

.search-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.search-field {
  flex-grow: 1;
}

.search-button {
  border-radius: 0;
  margin: 0;
  height: 100%;
}
</style>
